function isValidTarget(target: string | undefined | null): target is string {
  if (!target) {
    return false;
  }
  if (!target.startsWith('/')) {
    return false;
  }
  if (target.startsWith('/login')) {
    return false;
  }
  if (target.startsWith('/sign-up')) {
    return false;
  }
  return true;
}

export function getLoginRedirect(redirect_to: string | undefined | null): string {
  return isValidTarget(redirect_to) ? redirect_to : '/';
}
